module.exports = __webpack_public_path__ + "static/2-78030f76fad15b425f10bd25b5f7999a.svg";